import HttpClientToken from '../../services/HttpClientToken';

import { defaultMunicipio, MunicipioProps } from '../../interfaces/catalogos/MunicipioInterface';

export const Municipios = () => {

    return new Promise<MunicipioProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Municipio/', token)
            .then( ({ data } : { data : MunicipioProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerMunicipio = ( id: number ) => {

    return new Promise<MunicipioProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get(`/Api/Municipio/ObtenerMunicipios/${ id }`, token)
            .then( ({ data } : { data : MunicipioProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarMunicipio = ( params: MunicipioProps ) => {

    return new Promise<MunicipioProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Municipio/Actualizar', params, token)
            .then( ({ data } : { data : MunicipioProps} ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultMunicipio } );
            });

        }

    });

}

export const AgregarMunicipio = ( params: MunicipioProps ) => {

    return new Promise<MunicipioProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Municipio/Agregar', params, token)
            .then( ({ data } : { data : MunicipioProps} ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultMunicipio } );
            });

        }

    });

}
